import React from 'react';
import styled from 'styled-components';
import { Popconfirm } from 'tdesign-react';
import { isVoid } from '@/utils/common';
import { ReactComponent as IconSvg } from './icon.svg';
import { ReactComponent as ServerSvg } from './server.svg';

/**
 *
 * @param {*} param
 * @param {string} param.color
 * @param {string} param.children
 * @param {string} param.icon icon|server
 * @returns
 */
export default function OperateTag({
  color,
  children,
  icon = 'icon',
  operater,
  onPopConfirm,
  ...others
}) {
  return (
    <Root primaryColor={color} {...others}>
      {onPopConfirm ? (
        <Popconfirm
          content='跳转到该集群？'
          destroyOnClose
          placement='top'
          showArrow
          theme='default'
          popupProps={{ trigger: 'hover' }}
          onConfirm={onPopConfirm}
        >
          <BodyText>{children}</BodyText>
        </Popconfirm>
      ) : (
        <BodyText>{children}</BodyText>
      )}

      {operater}
      {icon === 'icon' && <IconSvg className='t-icon title-icon' />}
      {icon === 'server' && <ServerSvg className='t-icon title-icon' />}
    </Root>
  );
}

const Root = styled.div`
  border-radius: 6px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px 0 18px;
  box-sizing: border-box;
  background-color: ${(props) => props.primaryColor};
  color: white;
  position: relative;
  .title-icon {
    position: absolute;
    left: -9px;
    top: 0;
    bottom: 0px;
    width: auto;
    height: 24px;
    color: ${(props) => props.primaryColor};
    fill: #fff;
    box-sizing: border-box;
    border-radius: 100%;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  }
`;

const BodyText = styled.span`
  cursor: ${(props) => (isVoid(props.onClick) ? 'default' : 'pointer')};
`;
